<nz-spin nzSize="large" [nzSpinning]="loading$ | async">
  <header>
    <app-lot-last-visit-date [savedLot]="(data$ | async)?.savedLot"></app-lot-last-visit-date>
    <nz-result
      *ngIf="(loading$ | async) === false && !(data$ | async)?.lot"
      nzStatus="404"
      [nzTitle]="'LOT_NOT_FOUND' | translate"
    ></nz-result>
    <app-lot-title-full *ngIf="(data$ | async)?.lot as lot" [lot]="lot"></app-lot-title-full>
  </header>

  <ng-container *ngIf="data$ | async as data">
    <main *ngIf="data?.lot" nz-row nzGutter="16">
      <aside nz-col nzXs="24" nzLg="10">
        <section>
          <app-lot-carousel
            [lot]="data.lot"
            [lotType]="data.lotType"
            [lotSource]="data.lotSource"
            [currentUser]="data.currentUser"
            [isUsingSavedImages]="data.isUsingSavedImages"
            [(activeSlide)]="activeSlide"
            (mediaChanged)="refetch$.next()"
          ></app-lot-carousel>
        </section>

        <section>
          <app-alerts-list-auto
            [target]="'lot_page'"
            [auction]="data.lot.auctionName"
            [lotCode]="data.lot.bid"
            [company]="data.lot.company"
            [model]="data.lot.modelName"
            [frame]="data.lot.frame"
          ></app-alerts-list-auto>
        </section>
      </aside>

      <aside nz-col nzXs="24" nzLg="14">
        <section>
          <app-lot-translations
            id="lotTranslations"
            [translations]="data.translations"
          ></app-lot-translations>
          <app-lot-statistics
            *ngIf="data.lotType !== LotSource.Mikhail"
            [lot]="data.lot"
          ></app-lot-statistics>
        </section>

        <section *ngIf="data.savedLot" class="buttons">
          <app-share-button
            [savedLot]="data.savedLot"
            [lotType]="data.lotType"
            [lotSource]="data.lotSource"
            (lotShared)="refetch$.next()"
          ></app-share-button>
        </section>

        <section>
          <app-lot-check-production-date-input
            [lot]="data.lot"
            [lotType]="data.lotType"
            [lotSource]="data.lotSource"
            [fullVin]="data.fullVin"
            [limits]="data.limits"
            [currentUser]="data.currentUser"
            (inputFocus)="goToFirstSlide(data.isUsingSavedImages)"
          ></app-lot-check-production-date-input>
        </section>

        <section *ngIf="data.currentUser.countryIso === 'ru'">
          <app-lot-boundary-info
            [lot]="data.lot"
            [style]="'alert'"
            [excludeStatuses]="[BoundaryStatus.NotBoundary, BoundaryStatus.Early]"
          ></app-lot-boundary-info>
        </section>

        <section>
          <app-lot-main-info
            [lot]="data.lot"
            [lotType]="data.lotType"
            [lotSource]="data.lotSource"
            [bestBid]="data.bestBid"
            [hasBestBid]="data.hasBestBid"
            [currentUser]="data.currentUser"
            [currentUserLastBid]="data.currentUserLastBid"
            (actionComplete)="refetch$.next()"
          ></app-lot-main-info>
        </section>

        <section>
          <app-lot-check-production-date-result
            [lot]="data.lot"
          ></app-lot-check-production-date-result>
        </section>

        <section>
          <app-lot-extra-info [lot]="data.lot" [active]="true"></app-lot-extra-info>
        </section>
      </aside>
    </main>
  </ng-container>
</nz-spin>
